import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import axios from 'axios';
import dayjs from 'dayjs';
import moment from 'moment/moment';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import env from '../../config/env';
import jsonConfig from '../../config/index.json';
import MapItem from '../MapItem';
import ReviewItemVehicle from '../ReviewItemVehicle';

function DetailsAnnonceModal({ annonceID, vehiculeId }) {
  const annonceid = annonceID;
  const [Reviews, setReviews] = useState([]);

  const [annonces, setAnnonces] = useState({
    vehiculeAnnonceId: 1,
    reservationPrice: '300',
    locationMode: '0',
    vehiculeType: 'Voyage',
    vehiculeId: 1,
    minDistanceInclus: '0',
    additionalDriverInclus: '0',
    annulationAnnonceDelayBefore: '1',
    carburantInclus: '1',
    supplementJeuneDriver: '0',
    distanceOutMin: '300',
    locationAddress: 'Grenoble Gare',
    locationCoordinates: '45.1914,5.714',
    createdAt: '2024-01-29T16:53:03.000Z',
    updatedAt: '2024-01-29T16:53:07.000Z',
    Vehicle: {
      vehiculeId: 1,
      description: 'Voiture Tesla ',
      images: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Tesla_Model_Y_1X7A6211.jpg',
      modeleId: 1603,
      userId: 1,
      kilometrage: '2',
      VehicleModel: {
        id: 1603,
        marque: 'VOLVO',
        modele: '480',
      },
      UserProfile: {
        id: 1,
        firstName: 'Fatah',
        lastName: 'Ahmed',
        city: 'Paris',
        country: 'France',
        immatriculation: 'AXT5-780',
      },
    },
  });
  const [vehicleImages, setVehicleImages] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [DeliveryLocation, setDeliveryLocation] = useState(null);
  const [Availabilities, setAvailabilities] = useState(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const start = searchParams.get('start');
  const end = searchParams.get('end');

  var startDate = start.split(' ');
  // Reconstruire la chaîne de date dans un format reconnu par JavaScript
  startDate = startDate.slice(1, 4).join(' ') + ' ' + startDate[4] + ' ' + startDate[5];

  var endDate = end.split(' ');
  // Reconstruire la chaîne de date dans un format reconnu par JavaScript
  endDate = endDate.slice(1, 4).join(' ') + ' ' + endDate[4] + ' ' + endDate[5];

  var dateEntree = new Date(startDate);

  var dateSortie = new Date(endDate);

  var formattedDateIn =
    dateEntree.getFullYear() +
    '-' +
    ('0' + (dateEntree.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + dateEntree.getDate()).slice(-2);

  var formattedDateOut =
    dateSortie.getFullYear() +
    '-' +
    ('0' + (dateSortie.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + dateSortie.getDate()).slice(-2);

  const [DateIn, setDateIn] = useState(formattedDateIn);
  const [DateOut, setDateOut] = useState(formattedDateOut);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${env.baseUrlApi}/vehicleAnnonces/getannoncebyid/` + annonceid
        );
        if (response.data) {
          setAnnonces(response.data);
          setVehicleImages(response.data.Vehicle.images.split(','));
        }

        const responseOption = await axios.get(
          `${env.baseUrlApi}/vehicleOptionRecords/` + response.data.Vehicle.id
        );
        if (response.data) {
          setVehicleOptions(responseOption.data);
        }

        const DeliverLoc = await axios.get(
          `${env.baseUrlApi}/deliverylocation/getannoncebyid/` + annonceid
        );
        if (DeliverLoc.data) {
          setDeliveryLocation(DeliverLoc.data[0].addressEmplacementDelivery);
        }

        const avai = await axios.get(
          `${env.baseUrlApi}/availabilities/getbyvehiculeid/` + response.data.Vehicle.id
        );
        if (avai.data) {
          setAvailabilities(avai.data);
        }

        const discountsresp = await axios.get(
          `${env.baseUrlApi}/discounts/getbyvehiculeid/` + response.data.Vehicle.id
        );

        if (discountsresp.data) {
          setDiscounts(discountsresp.data);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${env.baseUrlApi}/reviews/getbyvehiculeId/` + annonces.Vehicle.id
        );
        if (response.data) {
          const sortedData = response.data.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
          setReviews(sortedData);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, [annonces]);

  const [selectedValue, setSelectedValue] = useState('08:30');
  const [selectedValue2, setSelectedValue2] = useState('22:30');

  // Fonction pour gérer le changement de sélection
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleChange2 = (event) => {
    setSelectedValue2(event.target.value);
  };

  // Fonction pour générer les options pour les heures
  const generateHourOptions = () => {
    const options = [];

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const hourString = hour.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const minuteString = minute.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const timeString = `${hourString}:${minuteString}`;
        options.push(
          <option key={timeString} value={timeString}>
            {timeString}
          </option>
        );
      }
    }

    return options;
  };

  const getDayOfWeek = (date) => {
    const day = date.getDay();
    return day === 0 ? 6 : day - 1;
  };

  function calculerPrixTotal(Availabilities, DateIn, DateOut) {
    let prixTotal = 0;

    // Convertir les dates en objets Date
    let dateActuelle = new Date(DateIn);
    const dateFin = new Date(DateOut);

    // Parcourir les jours entre DateIn et DateOut
    while (dateActuelle <= dateFin) {
      // Récupérer le jour de la semaine (0 pour Dimanche, 1 pour Lundi, ..., 6 pour Samedi)
      const jourSemaine = getDayOfWeek(dateActuelle);

      // Récupérer le prix correspondant au jour de la semaine
      let prixJour = 0;
      if (Availabilities) prixJour = Availabilities[jourSemaine]?.Default_price || 0.0;

      // Ajouter le prix au total
      prixTotal += prixJour;

      // Passer au jour suivant
      dateActuelle.setDate(dateActuelle.getDate() + 1);
    }

    return prixTotal;
  }

  const [CalcluatedPrice, setCalcluatedPrice] = useState(0);
  const [NombreJours, setNombreJours] = useState(0);
  const [IsUnaivalable, setIsUnaivalable] = useState(false);
  const [IsUnaivalableOut, setIsUnaivalableOut] = useState(false);

  const [StartDate, setStartDate] = useState(null);
  const [EndDate, setEndDate] = useState(null);
  const [Discounts, setDiscounts] = useState(null);
  const [OnboardingData, setOnboardingData] = useState('');
  const [ReductionPrix, setReductionPrix] = useState(0);

  const [DatePicker1, setDatePicker1] = useState(null);
  const [DatePicker2, setDatePicker2] = useState(null);

  // Fonction de gestion pour mettre à jour les dates sélectionnées
  const handleDateChange = (newDates) => {
    setSelectedDates(newDates);

    let date1 = new Date(newDates[0]?.$d);
    let date2 = new Date(newDates[1]?.$d);

    let formattedData1 = `${date1.getFullYear()}-${String(date1.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(date1.getDate()).padStart(2, '0')}`;

    let formattedData2 = `${date2.getFullYear()}-${String(date2.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(date2.getDate()).padStart(2, '0')}`;

    setDatePicker1(formattedData1);
    setDatePicker2(formattedData2);
    setDateIn(formattedData1);
    setDateOut(formattedData2);
  };
  let fraisVoyage = 8;
  let TVA = 2;
  useEffect(() => {
    if (DateIn && DateOut && Availabilities) {
      var difference = new Date(DateOut).getTime() - new Date(DateIn).getTime();
      // Convertir la différence de millisecondes en jours
      var nombre_de_jours = difference / (1000 * 3600 * 24);
      setNombreJours(nombre_de_jours);
      setCalcluatedPrice(nombre_de_jours * Availabilities[0].Default_price);
      if (Discounts.length > 0) {
        if (nombre_de_jours > 3) {
          setReductionPrix(Discounts['0'].pourcentage_reduction);
        } else if (nombre_de_jours > 7) {
          setReductionPrix(Discounts['1'].pourcentage_reduction);
        } else if (nombre_de_jours > 14) {
          setReductionPrix(Discounts['2'].pourcentage_reduction);
        } else if (nombre_de_jours > 30) {
          setReductionPrix(Discounts['3'].pourcentage_reduction);
        } else if (nombre_de_jours > 60) {
          setReductionPrix(Discounts['4'].pourcentage_reduction);
        }
      }
    }
  }, [DateIn, DateOut]);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${env.baseUrlApi}/unavailabilities/getbyvehiculeid-date/` +
            annonces.Vehicle.id +
            '?date=' +
            DateIn
        );
        if (response.data.length > 0) {
          setStartDate(response.data[0].start_date);
          setEndDate(response.data[0].end_date);
          setIsUnaivalable(true);
        } else setIsUnaivalable(false);

        const startDateObj = new Date(StartDate);
        const endDateObj = new Date(EndDate);
        const dateInObj = new Date(DateIn);
        const dateOutObj = new Date(DateOut);
        // Vérifier s'il y a chevauchement
        const isOverlap =
          (startDateObj <= dateInObj && dateInObj <= endDateObj) || // Vérifier si DateIn est dans [startDate, endDate]
          (startDateObj <= dateOutObj && dateOutObj <= endDateObj) || // Vérifier si DateOut est dans [startDate, endDate]
          (dateInObj <= startDateObj && endDateObj <= dateOutObj); // Vérifier si [startDate, endDate] est entièrement inclus dans [dateIn, dateOut]

        setIsUnaivalable(isOverlap);
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, [DateIn]);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${env.baseUrlApi}/unavailabilities/getbyvehiculeid-date/` +
            annonces.Vehicle.id +
            '?date=' +
            DateOut
        );
        if (response.data.length > 0) {
          setStartDate(response.data[0].start_date);
          setEndDate(response.data[0].end_date);
          setIsUnaivalable(true);
          setIsUnaivalableOut(true);
        } else {
          setIsUnaivalable(false);
          setIsUnaivalableOut(false);
        }

        const startDateObj = new Date(StartDate);
        const endDateObj = new Date(EndDate);
        const dateInObj = new Date(DateIn);
        const dateOutObj = new Date(DateOut);
        // Vérifier s'il y a chevauchement
        const isOverlap =
          (startDateObj <= dateInObj && dateInObj <= endDateObj) || // Vérifier si DateIn est dans [startDate, endDate]
          (startDateObj <= dateOutObj && dateOutObj <= endDateObj) || // Vérifier si DateOut est dans [startDate, endDate]
          (dateInObj <= startDateObj && endDateObj <= dateOutObj); // Vérifier si [startDate, endDate] est entièrement inclus dans [dateIn, dateOut]

        // setIsUnaivalable(isOverlap);
        setIsUnaivalableOut(isOverlap);
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, [DateOut]);

  function handleContinuer() {
    setOnboardingData(
      '&endDate=' +
        formattedDateOut +
        '&endTime=' +
        selectedValue2 +
        '&startDate=' +
        formattedDateIn +
        '&startTime=' +
        selectedValue +
        '&reservationLocationType=HOME' +
        '&vehicleId=' +
        annonces.Vehicle.id
    );
    window.location.href =
      `${env.apiUrl}/onboarding?action=CHECKOUT` +
      '&endDate=' +
      formattedDateOut +
      '&endTime=' +
      selectedValue2 +
      '&startDate=' +
      formattedDateIn +
      '&startTime=' +
      selectedValue +
      '&reservationLocationType=HOME' +
      '&vehicleId=' +
      annonces.Vehicle.id +
      '&NombreJour=' +
      NombreJours +
      '&priceU=' +
      Availabilities[0].Default_price +
      '&fraisVoyage=' +
      fraisVoyage +
      '&Tva=' +
      TVA +
      '&Reduction=' +
      ReductionPrix +
      '&FreeMinDistance=' +
      annonces.distanceOutMin +
      '&annonceId=' +
      annonces.vehiculeAnnonceId;
  }

  const [selectedFilters, setSelectedFilters] = useState([]);

  const [ratingsCount, setRatingsCount] = useState({});
  const [averageRating, setAverageRating] = useState(0);
  const [NBReviews, setNBReviews] = useState(0);

  useEffect(() => {
    // Calculer le nombre d'avis pour chaque rating
    const count = {};
    Reviews.forEach((review) => {
      count[review.rating] = (count[review.rating] || 0) + 1;
    });

    let totalRatings = 0;
    Reviews.forEach((review) => {
      count[review.rating] = (count[review.rating] || 0) + 1;
      totalRatings += parseInt(review.rating);
    });
    setRatingsCount(count);

    // Calculer le rating moyen
    const average = totalRatings / Reviews.length;
    setAverageRating(average);
    setNBReviews(Reviews.length);
  }, [Reviews]);

  const handleFilterChange = (filter) => {
    if (selectedFilters.includes(filter)) {
      setSelectedFilters(selectedFilters.filter((item) => item !== filter));
    } else {
      setSelectedFilters([...selectedFilters, filter]);
    }
  };

  const filteredReviews =
    selectedFilters.length === 0
      ? Reviews
      : Reviews.filter((review) => {
          return selectedFilters.includes(review.rating.toString());
        });

  const date1 = dayjs(dateEntree); // Date de début personnalisée
  const date2 = dayjs(dateSortie); // Date de fin personnalisée
  const [selectedDates, setSelectedDates] = useState([date1, date2]);

  useEffect(() => {
    if (dateEntree && dateSortie && Availabilities && Discounts) {
      var difference = new Date(dateSortie).getTime() - new Date(dateEntree).getTime();
      // Convertir la différence de millisecondes en jours
      var nombre_de_jours = difference / (1000 * 3600 * 24);

      setNombreJours(nombre_de_jours);
      setCalcluatedPrice(nombre_de_jours * Availabilities[0].Default_price);
      if (Discounts.length > 0) {
        if (nombre_de_jours > 3) {
          setReductionPrix(Discounts['0'].pourcentage_reduction);
        } else if (nombre_de_jours > 7) {
          setReductionPrix(Discounts['1'].pourcentage_reduction);
        } else if (nombre_de_jours > 14) {
          setReductionPrix(Discounts['2'].pourcentage_reduction);
        } else if (nombre_de_jours > 30) {
          setReductionPrix(Discounts['3'].pourcentage_reduction);
        } else if (nombre_de_jours > 60) {
          setReductionPrix(Discounts['4'].pourcentage_reduction);
        }
      }
    }
  }, [Availabilities]);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${env.baseUrlApi}/unavailabilities/getbyvehiculeid/` + vehiculeId
        );

        if (response.data.length > 0) {
          for (var i = 0; i < response.data.length; i++) {
            const startDateObj = new Date(response.data[i].start_date);
            const endDateObj = new Date(response.data[i].end_date);
            const dateInObj = dateEntree;
            const dateOutObj = dateSortie;
            // Vérifier s'il y a chevauchement

            const isOverlap =
              (startDateObj <= dateInObj && dateInObj <= endDateObj) || // Vérifier si DateIn est dans [startDate, endDate]
              (startDateObj <= dateOutObj && dateOutObj <= endDateObj) || // Vérifier si DateOut est dans [startDate, endDate]
              (dateInObj <= startDateObj && endDateObj <= dateOutObj); // Vérifier si [startDate, endDate] est entièrement inclus dans [dateIn, dateOut]

            setIsUnaivalable(isOverlap);
            if (isOverlap === true) break;
          }
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  return (
    <>
      <div id="myCarousel" class="carousel slide mb-6 pointer-event" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#myCarousel"
            data-bs-slide-to="0"
            class=""
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#myCarousel"
            data-bs-slide-to="1"
            aria-label="Slide 2"
            class="active"
            aria-current="true"
          ></button>
          <button
            type="button"
            data-bs-target="#myCarousel"
            data-bs-slide-to="2"
            aria-label="Slide 3"
            class=""
          ></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item">
            <img src={vehicleImages[0]} alt="" width={' 100%'} />
          </div>
          <div class="carousel-item active">
            <img src={vehicleImages[1]} alt="" width={'100%'} />
          </div>
          <div class="carousel-item">
            <img src={vehicleImages[2]} alt="" width={'100%'} />{' '}
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#myCarousel"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#myCarousel"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
      <section className="mb-3">
        <div className="container">
          <div class="">
            <div className="row">
              <div className="col-md-8 mb-3">
                <div className="w-100 d-md-block my-div">
                  <h1>{annonces.Vehicle.description}</h1>
                  <span className="mb-3">
                    <strong>5.0</strong> (1 Voyage)
                  </span>
                  <div className="row mb-3">
                    <div className="col">
                      <div className="row mb-2">
                        {' '}
                        <div className="col-1 me-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30px"
                            height="30px"
                            viewBox="0 0 24 24"
                            class="seo-pages-0"
                            role="img"
                            version="1.1"
                          >
                            <path
                              fill="#121214"
                              fill-rule="evenodd"
                              d="M9.58 15.24c0 1.6 1.3 2.9 2.9 2.9a2.9 2.9 0 0 0 2.89-2.9c0-1.02-1.11-3.29-2.04-5.02-.34-.63-1.37-.63-1.71 0-.93 1.73-2.04 4-2.04 5.02Zm1.25 0c0-.52.64-2.05 1.65-3.97 1.01 1.92 1.64 3.46 1.65 3.97 0 .91-.74 1.65-1.65 1.65-.91 0-1.65-.74-1.65-1.65Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#121214"
                              fill-rule="evenodd"
                              d="M20.95 22.35V1.62c0-.34-.27-.62-.62-.62h-4.87c-1.04 0-2.04.39-2.8 1.1a.61.61 0 0 0-.04.88c.24.25.63.27.89.03.53-.49 1.22-.76 1.95-.76h4.25V4.5H9.84c-.16 0-.32.07-.44.18L4.19 9.89c-.11.11-.18.27-.18.44v12.03c0 .34.27.62.62.62h15.7c.35 0 .63-.28.62-.63Zm-1.24-.62H5.26V10.59l4.84-4.84h9.61v15.98Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#121214"
                              d="M4.18 7.43a.63.63 0 0 0 .89-.01l1.85-1.85c.24-.24.24-.64 0-.88a.628.628 0 0 0-.88 0L4.18 6.55c-.24.24-.24.64 0 .88Z"
                            ></path>
                          </svg>
                        </div>
                        <div className="col">
                          {jsonConfig.carburant[annonces.Vehicle.carburantType]}
                        </div>
                      </div>
                      <div className="row">
                        {' '}
                        <div className="col-1 me-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30px"
                            height="30px"
                            fill="none"
                            viewBox="0 0 24 24"
                            class="seo-pages-0"
                            role="img"
                            version="1.1"
                          >
                            <path
                              fill="#121214"
                              fill-rule="evenodd"
                              d="M14.32 5.75h1.16c.45 0 .86-.23 1.11-.6.25-.37.3-.84.13-1.25l-.35-.86a1.83 1.83 0 0 0-1.7-1.14H9.29c-.75 0-1.42.45-1.7 1.15l-.35.86c-.17.41-.12.88.13 1.25s.66.59 1.11.59h1.16v.992A3.484 3.484 0 0 0 6.34 9.6l-.89 4.85c-.08.41-.09.81-.03 1.2a2.877 2.877 0 0 0-1.92 2.7v.8c0 1.58 1.28 2.87 2.86 2.87h11.21a2.88 2.88 0 0 0 2.87-2.86v-.8c0-1.48-1.16-2.73-2.63-2.85-.28-.02-.55.17-.65.44a2.443 2.443 0 0 1-2.68 1.59l-.92-.15c-.63-.1-1.26-.13-1.88-.11-.03 0-.69.01-1.3.11l-.91.15c-.79.13-1.57-.13-2.13-.7-.25-.25-.43-.54-.55-.85a.358.358 0 0 0-.04-.11 2.51 2.51 0 0 1-.07-1.19l.89-4.86A2.24 2.24 0 0 1 9.77 8h4.39c1.08 0 2 .77 2.2 1.83l.68 3.71a.626.626 0 0 0 1.23-.23l-.68-3.71a3.484 3.484 0 0 0-3.27-2.856V5.75Zm-1.24 0h-2.2v.99h2.2v-.99Zm-3.79-2.6c-.24 0-.45.14-.54.37l-.35.86.08.12h7c.01 0 .05 0 .07-.04l-.34-.94a.577.577 0 0 0-.54-.36H9.29v-.01ZM5.81 16.84c-.62.23-1.06.83-1.06 1.51v.8c0 .89.72 1.61 1.61 1.61h11.2c.89 0 1.61-.72 1.61-1.61v-.8c0-.69-.44-1.29-1.07-1.52-.75 1.4-2.28 2.18-3.84 1.93l-.91-.15c-.54-.09-1.1-.12-1.64-.1-.01 0-.61.01-1.14.1l-.91.15c-1.2.19-2.37-.2-3.22-1.07-.26-.25-.47-.54-.63-.85Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#121214"
                              fill-rule="evenodd"
                              d="M13.87 16.27a1.558 1.558 0 0 0 1.37-.46c.36-.37.51-.89.42-1.4l-.58-3.19a2.047 2.047 0 0 0-2.01-1.68h-2.19c-.99 0-1.83.71-2.01 1.68l-.58 3.18c-.09.51.07 1.03.43 1.4.36.37.87.54 1.39.46l1.23-.2c.4-.06.81-.06 1.21 0l1.32.21Zm-1.14-1.44a5.322 5.322 0 0 0-1.59 0l-1.23.2a.35.35 0 0 1-.3-.1.338.338 0 0 1-.09-.3l.58-3.18c.07-.38.4-.65.78-.65h2.2c.38 0 .71.27.78.65l.58 3.19c.03.15-.04.25-.09.3a.35.35 0 0 1-.3.1l-1.32-.21Z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </div>
                        <div className="col">
                          {jsonConfig.siegeNumber[annonces.Vehicle.siegeNumber]} Sièges
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="row">
                        {' '}
                        <div className="col-1 me-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30px"
                            height="30px"
                            fill="none"
                            viewBox="0 0 24 24"
                            class="seo-pages-0"
                            role="img"
                            version="1.1"
                          >
                            <path
                              fill="#121214"
                              d="M19.67 21.45H7.27c-1.33 0-2.5-.85-2.91-2.1l-2.2-6.68c-.38-1.14-.05-2.4.83-3.21l6.08-5.63c.8-.75 2.28-1.33 3.38-1.33h8.92c.35 0 .62.28.62.62 0 .34-.28.62-.62.62h-8.92c-.78 0-1.96.46-2.53.99l-6.09 5.64c-.52.48-.71 1.23-.49 1.9l2.2 6.68c.25.75.94 1.25 1.72 1.25h12.4c.59 0 1.07-.48 1.07-1.07V5.51c0-.34.28-.62.62-.62.34 0 .62.28.62.62v13.61a2.3 2.3 0 0 1-2.3 2.33Z"
                            ></path>
                            <path
                              fill="#121214"
                              fill-rule="evenodd"
                              d="M18.15 11.33H6.92c-.7 0-.93-.39-1-.56-.06-.17-.16-.62.35-1.1l4.27-4.03c.46-.43 1.27-.76 1.9-.76h5.71c.81 0 1.47.66 1.47 1.47v3.51c0 .81-.66 1.47-1.47 1.47Zm-10.5-1.25h10.5c.13 0 .22-.1.22-.22v-3.5c0-.12-.1-.22-.22-.22h-5.71c-.31 0-.82.2-1.04.42l-3.75 3.52Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#121214"
                              d="M17.04 13.72h1.95c.35 0 .62-.28.62-.62 0-.34-.27-.62-.62-.62h-1.95c-.34 0-.62.28-.62.62 0 .34.27.62.62.62Z"
                            ></path>
                          </svg>
                        </div>
                        <div className="col">
                          {jsonConfig.porteNumber[annonces.Vehicle.porteNumber]} portes
                        </div>
                      </div>
                    </div>
                  </div>
                  <h3>Votre hote</h3>
                  <div className="d-lex justify-content-center mb-3">
                    <div>
                      <img src="" alt="" />
                    </div>
                    <div>
                      <span>
                        <strong>
                          {annonces?.Vehicle?.UserProfile?.firstName}{' '}
                          {annonces?.Vehicle?.UserProfile?.lastName}.
                        </strong>
                      </span>
                      <p>
                        1 Voyage.{' '}
                        <span className="text-success">
                          Membre depuis le{' '}
                          {moment(annonces?.Vehicle?.UserProfile?.createdAt).calendar()}
                        </span>
                      </p>
                      <small className="text-muted">Répond habituellement en 1 minute</small>
                      <p>{annonces.Vehicle.description}</p>

                      {/* <button
                      className="btn btn-primary mb-3"
                      onClick={handleDisplayMore}
                    >
                      {moreDiplayMsg}
                    </button> */}

                      <div className="row">
                        {vehicleOptions &&
                          vehicleOptions.map((option, index) => (
                            <div key={index} className="col-md-4">
                              <p>
                                <span className="badge bg-tertiary">
                                  {option.VehicleOption.name}
                                </span>
                              </p>
                            </div>
                          ))}
                      </div>
                      <h3>Évaluations et commentaires</h3>
                      <span>{averageRating}</span>
                      <p>{NBReviews} évaluation</p>
                      <dl className="row">
                        <dt className="col-sm-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="5"
                              id="excellentCheckbox"
                              checked={selectedFilters.includes('5')}
                              onChange={() => handleFilterChange('5')}
                            />
                            <label className="form-check-label" htmlFor="excellentCheckbox">
                              EXCELLENT
                            </label>
                          </div>
                        </dt>
                        <dd className="col-sm-9">
                          <div
                            className="progress"
                            role="progressbar"
                            aria-label="Excellent Progress"
                            aria-valuenow={
                              ratingsCount['5'] ? (ratingsCount['5'] / Reviews.length) * 100 : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div
                              className="progress-bar"
                              style={{
                                width: `${
                                  ratingsCount['5'] ? (ratingsCount['5'] / Reviews.length) * 100 : 0
                                }%`,
                              }}
                            >
                              {ratingsCount['5']
                                ? `${((ratingsCount['5'] / Reviews.length) * 100).toFixed(2)}%`
                                : ''}
                            </div>
                          </div>
                        </dd>

                        <dt className="col-sm-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="4"
                              id="veryGoodCheckbox"
                              checked={selectedFilters.includes('4')}
                              onChange={() => handleFilterChange('4')}
                            />
                            <label className="form-check-label" htmlFor="veryGoodCheckbox">
                              TRES BIEN
                            </label>
                          </div>
                        </dt>
                        <dd className="col-sm-9">
                          <div
                            className="progress"
                            role="progressbar"
                            aria-label="Very Good Progress"
                            aria-valuenow={
                              ratingsCount['4'] ? (ratingsCount['4'] / Reviews.length) * 100 : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div
                              className="progress-bar"
                              style={{
                                width: `${
                                  ratingsCount['4'] ? (ratingsCount['4'] / Reviews.length) * 100 : 0
                                }%`,
                              }}
                            >
                              {ratingsCount['4']
                                ? `${((ratingsCount['4'] / Reviews.length) * 100).toFixed(2)}%`
                                : ''}
                            </div>
                          </div>
                        </dd>

                        <dt className="col-sm-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="3"
                              id="veryGoodCheckbox"
                              checked={selectedFilters.includes('3')}
                              onChange={() => handleFilterChange('3')}
                            />
                            <label className="form-check-label" htmlFor="veryGoodCheckbox">
                              MOYEN
                            </label>
                          </div>
                        </dt>
                        <dd className="col-sm-9">
                          <div
                            className="progress"
                            role="progressbar"
                            aria-label="Very Good Progress"
                            aria-valuenow={
                              ratingsCount['3'] ? (ratingsCount['3'] / Reviews.length) * 100 : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div
                              className="progress-bar"
                              style={{
                                width: `${
                                  ratingsCount['3'] ? (ratingsCount['3'] / Reviews.length) * 100 : 0
                                }%`,
                              }}
                            >
                              {ratingsCount['3']
                                ? `${((ratingsCount['3'] / Reviews.length) * 100).toFixed(2)}%`
                                : ''}
                            </div>
                          </div>
                        </dd>

                        <dt className="col-sm-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="2"
                              id="veryGoodCheckbox"
                              checked={selectedFilters.includes('2')}
                              onChange={() => handleFilterChange('2')}
                            />
                            <label className="form-check-label" htmlFor="veryGoodCheckbox">
                              PASSABLE
                            </label>
                          </div>
                        </dt>
                        <dd className="col-sm-9">
                          <div
                            className="progress"
                            role="progressbar"
                            aria-label="Very Good Progress"
                            aria-valuenow={
                              ratingsCount['2'] ? (ratingsCount['2'] / Reviews.length) * 100 : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div
                              className="progress-bar"
                              style={{
                                width: `${
                                  ratingsCount['2'] ? (ratingsCount['2'] / Reviews.length) * 100 : 0
                                }%`,
                              }}
                            >
                              {ratingsCount['2']
                                ? `${((ratingsCount['2'] / Reviews.length) * 100).toFixed(2)}%`
                                : ''}
                            </div>
                          </div>
                        </dd>

                        <dt className="col-sm-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="2"
                              id="veryGoodCheckbox"
                              checked={selectedFilters.includes('1')}
                              onChange={() => handleFilterChange('1')}
                            />
                            <label className="form-check-label" htmlFor="veryGoodCheckbox">
                              MAUVAIS
                            </label>
                          </div>
                        </dt>
                        <dd className="col-sm-9">
                          <div
                            className="progress"
                            role="progressbar"
                            aria-label="Very Good Progress"
                            aria-valuenow={
                              ratingsCount['1'] ? (ratingsCount['1'] / Reviews.length) * 100 : 0
                            }
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <div
                              className="progress-bar"
                              style={{
                                width: `${
                                  ratingsCount['1'] ? (ratingsCount['1'] / Reviews.length) * 100 : 0
                                }%`,
                              }}
                            >
                              {ratingsCount['1']
                                ? `${((ratingsCount['1'] / Reviews.length) * 100).toFixed(2)}%`
                                : ''}
                            </div>
                          </div>
                        </dd>

                        {/* Ajoutez des entrées similaires pour les autres options de filtrage */}
                      </dl>
                      <div className="col-md-8 mb-3">
                        {filteredReviews &&
                          filteredReviews.map((conv) => (
                            <ReviewItemVehicle
                              annuler={true}
                              data={conv}
                              key={conv.id}
                            ></ReviewItemVehicle>
                          ))}
                      </div>

                      {filteredReviews.length === 0 && (
                        <small className="text-muted">II n’y a pas assez d’évaluations</small>
                      )}
                      <h3>Commentaires</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="w-100 d-md-block my-div">
                  <h2 className="mb-2">
                    {DateIn && DateOut && (
                      <strong>
                        {calculerPrixTotal(Availabilities, DateIn, DateOut)}€ au total
                      </strong>
                    )}
                  </h2>
                  <a
                    className="mb-3"
                    data-bs-toggle="offcanvas"
                    href={'#offcanvasExample' + annonceID}
                    role="button"
                    aria-controls={'offcanvasExample' + annonceID}
                  >
                    Voir les prix en détails
                  </a>

                  <hr />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateRangePicker']}>
                      <DateRangePicker
                        localeText={{ start: 'Début', end: 'Fin' }}
                        value={selectedDates} // Valeur des dates sélectionnées
                        onChange={handleDateChange} // Fonction de gestion pour les changements de dates
                        renderInput={(startProps, endProps) => (
                          <>
                            <input {...startProps} />
                            <input {...endProps} />
                          </>
                        )}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <div class=" mt-3 d-flex justify-content-between w-100 p">
                    <div className="col-md-5">
                      <select
                        class="form-select form-select-lg mb-3"
                        aria-label="Small select example"
                        value={selectedValue}
                        onChange={handleChange}
                      >
                        {generateHourOptions()}
                      </select>
                    </div>
                    <span>--</span>
                    <div className="col-md-5">
                      <select
                        class="form-select form-select-lg mb-3"
                        aria-label="Small select example"
                        value={selectedValue2}
                        onChange={handleChange2}
                      >
                        {generateHourOptions()}
                      </select>
                    </div>
                  </div>
                  <hr />
                  {/* <small>Début</small>
                  <div class="d-flex justify-content-start">
                    <div class="mb-3 me-2">
                      <input
                        type="date"
                        class="form-control"
                        id="exampleFormControlInput1"
                        value={DateIn}
                        onChange={(e) => setDateIn(e.target.value)}
                      />
                    </div>
                    <select
                      class="form-select form-select-sm mb-3"
                      aria-label="Small select example"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      {generateHourOptions()}
                    </select>
                  </div>

                  <small>Fin</small>
                  <div class="d-flex justify-content-start">
                    <div class="mb-3 me-2">
                      <input
                        type="date"
                        class="form-control"
                        id="exampleFormControlInput1"
                        value={DateOut}
                        onChange={(e) => setDateOut(e.target.value)}
                      />
                    </div>
                    <select
                      class="form-select form-select-sm mb-3"
                      aria-label="Small select example"
                      value={selectedValue2}
                      onChange={handleChange2}
                    >
                      {generateHourOptions()}
                    </select>
                  </div> */}

                  <span className="mb-3">
                    <strong>Lieu de prise en charge et de retour</strong>
                  </span>
                  <p>{DeliveryLocation}</p>
                  <div className=" small text-muted mb-2">
                    Nous vous enverrons l’adresse complète dès que votre trajet sera réservé.
                  </div>

                  <div
                    class="offcanvas offcanvas-start"
                    tabindex="-1"
                    id={'offcanvasExample' + annonceID}
                    aria-labelledby={'offcanvasExampleLabel' + annonceID}
                  >
                    <div class="offcanvas-header">
                      <h5 class="offcanvas-title" id={'offcanvasExampleLabel' + annonceID}>
                        Détails du prix
                      </h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="offcanvas-body">
                      <dl class="row">
                        <dt class="col-sm-3">
                          {CalcluatedPrice} € × {NombreJours + 1} jour
                        </dt>
                        {Availabilities && (
                          <dd class="col-sm-9">
                            {calculerPrixTotal(Availabilities, DateIn, DateOut)}
                          </dd>
                        )}

                        <dt class="col-sm-3">Frais de voyage</dt>
                        <dd class="col-sm-9">
                          <p>{fraisVoyage}€</p>
                        </dd>

                        <dt class="col-sm-3">TVA</dt>
                        <dd class="col-sm-9">{TVA}€</dd>

                        <dt class="col-sm-3 text-truncate">Total</dt>
                        <dd class="col-sm-9">{fraisVoyage + TVA}€</dd>
                      </dl>
                    </div>
                  </div>

                  {/* <p className="text-danger">
                    <ion-icon name="information-circle-outline"></ion-icon>Il
                    s’agit de votre véhicule
                  </p> */}

                  {NombreJours > 3 && Discounts.length > 0 && (
                    <div className="alert alert-success mb-2">
                      Réduction pour 3 jours ou plus:{' '}
                      <strong className="">
                        {(Discounts['0'].pourcentage_reduction *
                          calculerPrixTotal(Availabilities, DateIn, DateOut)) /
                          100}
                        €
                      </strong>
                    </div>
                  )}

                  {!IsUnaivalable &&
                    !IsUnaivalableOut &&
                    NombreJours > 7 &&
                    Discounts.length > 0 && (
                      <div className="alert alert-success mb-2">
                        Réduction pour 7 jours ou plus:{' '}
                        <strong className="">
                          {(Discounts['1'].pourcentage_reduction *
                            calculerPrixTotal(Availabilities, DateIn, DateOut)) /
                            100}
                          €
                        </strong>
                      </div>
                    )}

                  {!IsUnaivalable &&
                    !IsUnaivalableOut &&
                    NombreJours > 14 &&
                    Discounts.length > 0 && (
                      <div className="alert alert-success mb-2">
                        Réduction pour 2 semaines ou plus:{' '}
                        <strong className="">
                          {(Discounts['2'].pourcentage_reduction *
                            calculerPrixTotal(Availabilities, DateIn, DateOut)) /
                            100}
                          €
                        </strong>
                      </div>
                    )}
                  {!IsUnaivalable &&
                    !IsUnaivalableOut &&
                    NombreJours > 30 &&
                    Discounts.length > 0 && (
                      <div className="alert alert-success mb-2">
                        Réduction pour 30 jours ou plus:{' '}
                        <strong className="">
                          {(Discounts['3'].pourcentage_reduction *
                            calculerPrixTotal(Availabilities, DateIn, DateOut)) /
                            100}
                          €
                        </strong>
                      </div>
                    )}

                  {!IsUnaivalable &&
                    !IsUnaivalableOut &&
                    NombreJours > 60 &&
                    Discounts.length > 0 && (
                      <div className="alert alert-success mb-2">
                        Réduction pour 2 mois ou plus:{' '}
                        <strong className="">
                          {(Discounts['4'].pourcentage_reduction *
                            calculerPrixTotal(Availabilities, DateIn, DateOut)) /
                            100}
                          €
                        </strong>
                      </div>
                    )}
                  <button
                    className="btn btn-tertiary w-100 mb-2"
                    disabled={IsUnaivalable}
                    onClick={handleContinuer}
                  >
                    Continuer
                  </button>
                  {IsUnaivalable && (
                    <div className="small alert alert-danger">
                      Cette voiture n’est pas disponible pour la période indiquée.
                    </div>
                  )}
                  <hr />
                  <div className="d-flex justify-content-center">
                    <ion-icon name="heart-dislike-outline"></ion-icon>
                    <div>
                      <p>
                        <span>
                          <strong>Annulation gratuite</strong>
                        </span>
                      </p>
                      <p className="text-muted">Remboursement complet avant le 18 janv., 10:00</p>
                    </div>
                  </div>
                  <hr />

                  <p className="text-align-left">Distance incluse: {annonces.distanceOutMin} km </p>

                  <small className="text-muted text-align-left">
                    Frais de 0,13€ pour chaque kilomètre supplémentaire parcouru
                  </small>
                  <hr />
                  <div className="text-align-left">
                    <p>Assurance et protection</p>
                    <p>Assurance fournie par AXA France</p>
                  </div>

                  <hr className="text-muted" />

                  <button className="btn btn-success w-100 mb-2">Ajouter aux favoris</button>
                  <hr />
                  <div className="d-flex align-items-center flex-column mb-3">
                    <a className="mb-2" href="#">
                      Signaler l'annonce
                    </a>
                    <a href="#">Condition d'annulation</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MapItem
        centers={Array(annonces)}
        centercoords={[
          parseFloat(annonces.locationCoordinates.split(',')[0]),
          parseFloat(annonces.locationCoordinates.split(',')[1]),
        ]}
      ></MapItem>
    </>
  );
}

export default DetailsAnnonceModal;
